// extracted by mini-css-extract-plugin
module.exports = {"button_box":"PayReportsDownloadModal__button_box--1sXdb","button_frame":"PayReportsDownloadModal__button_frame--2fX6u"};